import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class AttributeRequirementsDict
*  Настройки атрибута, связанного со справочником
*/
export class AttributeRequirementsDict extends ActiveModel {

  /**
  * type
  *   */
  @ActiveField({ readonly: true, value: () => 'Dict' })
  readonly type: string = 'Dict'


  /**
  * dictionaryId
  * Идентификатор справочника  */
  @ActiveField()
  dictionaryId?: number
}
